import React from "react";

function ConfirmPopupActivity({ setIsConfirmPopup, handleSubmit }) {
    return (
        <div className="ContainerSubmitedSucessConfirm">
            <div className="SubContainerSubmitedSucessConfirm">
                <img
                    className="deactive_closeBtn"
                    src="/images/cross-circle3.svg"
                    alt="close"
                    onClick={() => setIsConfirmPopup(false)}
                />
                <div className="col-12 deactivate_msg" style={{ marginBottom: "30px", fontSize: "20px" }}>
                    {`Are you sure you want to submit?`}
                </div>
                <div className="row col-12 publish_deactive_btnBox">
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={handleSubmit}>
                        Yes
                    </button>
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => setIsConfirmPopup(false)}>
                        No
                    </button>
                </div>
            </div>
        </div>
    )

}

export default ConfirmPopupActivity;
